var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center min-h-screen px-2 pt-2 pb-6 bg-white body-bg md:pt-20 md:px-0"},[_c('div',{staticClass:"container flex overflow-hidden rounded-md"},[_c('router-view',{staticClass:"flex-1 overflow-hidden"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }